const cellOutlineStyle = {
  //pointerEvents:'none',
  position:'absolute',
  top:0,left:0,
  width:'100%',
  height:'100%',
  borderTop:'0.5px solid #ccc',
  borderBottom:'0.5px solid #ccc',
  borderLeft:'0.25px solid #ccc',
  borderRight:'0.25px solid #ccc',
  pointerEvents:'none',
}

export default function GridCellOutline(){ return (

    <div 
      sciugorole="table-outline"
      style={cellOutlineStyle}/>
  )
}
